//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message } from 'element-ui'
import {login} from '../comon/api/home'
  export default {
    data () {
      return {
        dataForm: {
          userName: '',
          password: '',
          uuid: '',
          captcha: ''
        },
        dataRule: {
          userName: [
            { required: true, message: '帐号不能为空', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '验证码不能为空', trigger: 'blur' }
          ]
        },
        captchaPath: ''
      }
    },
    created () {
    },
    methods: {
      jumpForget(){
        this.$router.push({
                  path: '/forgetPwd'
                })
      },
      // 提交表单
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            login({
              username: this.dataForm.userName,
              password: this.dataForm.password
            }).then(res => {
              if(res.code == 200) {
                localStorage.setItem('sessionId', res.data.sessionId)
                localStorage.setItem('session_pc', res.data.sessionId)
                localStorage.setItem('userInfo', res.data.userInfo.menuId)
                localStorage.setItem('userInfos', JSON.stringify(res.data.userInfo))
                this.$router.push({
                  path: '/home'
                })
              } else {
                Message.success(`${res.msg}`)
              }
            }).catch(err => {
              console.log(err)
            })
          }
        })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/Login.vue